import React from "react";
import { rightDirectionBlackIcon } from "../../../assets";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import WrapperCard from "../../../component-lib/Atoms/card/EventEHRWrapperCard";
import useDeviceType from "../../../custom-hooks/DeviceType";
import { useNavigate } from "react-router-dom";
import EventEHRProfileDetailsCard from "../../../component-lib/show-profile-details-card/EventEHRProfileDetailsCard";
import { getLoginUserData } from "../../../utils/getToken";
import { formatPhoneNumber } from "../../../utils/phoneNumberFormatter";

const UserProfilePage = () => {
  const loginUserData: any = getLoginUserData();
  const parsedLoginUserData = JSON.parse(loginUserData);

  const deviceType = useDeviceType();
  const navigate = useNavigate();
  const fullName = parsedLoginUserData.name;
  // USER DATA
  const userDetails = [
    {
      label: "Full Name",
      value: fullName || "-",
    },

    {
      label: "Email",
      value: parsedLoginUserData.email || "-",
    },
    {
      label: "Role",
      value: parsedLoginUserData.roleNames?.[0] || "-",
    },
    {
      label: "Phone",
      value: formatPhoneNumber(parsedLoginUserData.phone) || "-",
    },
    {
      label: "Status",
      value: parsedLoginUserData.status === "enabled" ? "Active" : "Inactive",
    },
  ];

  return (
    <WrapperCard
      customClasses="m-3 p-3 flex-1 min-h-0"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col h-full gap-3">
        {/*  SCREEN HEADER */}
        <div className={`flex items-center justify-between w-full`}>
          <div className="flex items-center gap-3">
            <img
              className="cursor-pointer"
              src={rightDirectionBlackIcon}
              alt="back-arrow"
              style={{ height: "12.5px" }}
              onClick={() => {
                navigate("/settings");
              }}
            />
            <Heading title="My Profile" />
          </div>
          {/* <Button
            startIcon={
              <img
                src={BluePencilSimpleIcon}
                alt={"search"}
                className="cursor-pointer w-[19px] h-[19px]"
              />
            }
            label="Edit Profile"
            variant="outlined"
            onClickCb={() => {
            }}
            style={{
              paddingTop: "6px",
              paddingBottom: "6px",
              minWidth: "155px",
            }}
          ></Button> */}
        </div>
        <div className="mt-1">
          <EventEHRProfileDetailsCard
            patientDetails={userDetails}
            customImageStyle={{ alignSelf: undefined }}
          />
        </div>
      </div>
    </WrapperCard>
  );
};

export default UserProfilePage;
